// extracted by mini-css-extract-plugin
export var grid = "_32-0";
export var span1 = "_32-2";
export var span10 = "_32-b";
export var span10L = "_32-z";
export var span10M = "_32-n";
export var span10Xl = "_32-1b";
export var span11 = "_32-c";
export var span11L = "_32-10";
export var span11M = "_32-o";
export var span11Xl = "_32-1c";
export var span12 = "_32-d";
export var span12L = "_32-11";
export var span12M = "_32-p";
export var span12Xl = "_32-1d";
export var span1L = "_32-q";
export var span1M = "_32-e";
export var span1Xl = "_32-12";
export var span2 = "_32-3";
export var span2L = "_32-r";
export var span2M = "_32-f";
export var span2Xl = "_32-13";
export var span3 = "_32-4";
export var span3L = "_32-s";
export var span3M = "_32-g";
export var span3Xl = "_32-14";
export var span4 = "_32-5";
export var span4L = "_32-t";
export var span4M = "_32-h";
export var span4Xl = "_32-15";
export var span5 = "_32-6";
export var span5L = "_32-u";
export var span5M = "_32-i";
export var span5Xl = "_32-16";
export var span6 = "_32-7";
export var span6L = "_32-v";
export var span6M = "_32-j";
export var span6Xl = "_32-17";
export var span7 = "_32-8";
export var span7L = "_32-w";
export var span7M = "_32-k";
export var span7Xl = "_32-18";
export var span8 = "_32-9";
export var span8L = "_32-x";
export var span8M = "_32-l";
export var span8Xl = "_32-19";
export var span9 = "_32-a";
export var span9L = "_32-y";
export var span9M = "_32-m";
export var span9Xl = "_32-1a";
export var stretch = "_32-1";